import React from 'react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { PRODUCT_NAME, tomos } from '../data/content';
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-mist" data-id="element-138" data-mp="3o90phaeoyenn">
      <div className="mx-auto max-w-3xl px-4 py-6 sm:px-6 sm:py-8" data-id="element-139" data-mp="3o77itv42vufn">
        <SectionHeading id="solucion" eyebrow="La solución que estabas buscando — un sistema 6 en 1" title="6 tomos en un solo sistema, creados para aprender seguridad electrónica desde cero." data-id="element-140" data-mp="3j9ftn8utimf5" />

        <p className="mx-auto mt-2.5 w-fit rounded-lg bg-navy px-3 py-1.5 text-center font-display text-xs font-extrabold text-white sm:text-sm" data-id="element-141" data-mp="3t6aptl3mcaq9">
          🛡️ {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-2 max-w-xl text-center text-[0.8rem] leading-snug text-graphite-muted sm:text-sm" data-id="element-142" data-mp="5w2wxok8ao3i">
          No es simplemente otro ebook de seguridad electrónica. Es una ruta de
          aprendizaje que organiza los conocimientos fundamentales para que
          comprendas qué aprender primero, qué viene después y cómo se conecta
          cada sistema.
        </p>

        <ol className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-143" data-mp="3ba8ocfuljem9">
          {tomos.map((tomo, i) => <Reveal key={tomo.title} as="li" delay={i * 0.03} className="rounded-xl bg-white p-3" data-id="element-144" data-mp="3f9qxyfgyw39s" data-mpi={i}>
              <div className="flex items-center gap-2" data-id="element-145" data-mp="3pa9qdymlks3b">
                <span className="shrink-0 rounded-md bg-navy px-2 py-0.5 font-display text-[0.65rem] font-bold text-electric" data-id="element-146" data-mp="3p7doy0bjjla4">
                  TOMO {i + 1}
                </span>
                <h3 className="font-display text-[0.8rem] font-extrabold leading-tight text-navy sm:text-sm" data-id="element-147" data-mp="2up0jwcp2oel">
                  {tomo.title}
                </h3>
              </div>
              <p className="mt-1.5 text-[0.8rem] leading-snug text-graphite-muted sm:text-sm" data-id="element-148" data-mp="bvwl7bmafqq7">
                {tomo.desc}
              </p>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}